import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';

export class LoadShiftManningAdminLog {
  static readonly type = '[ShiftManningAdminLog] Load admin log';
  constructor(public filter?: MainTableFilterModel) {}
}

export class ClearShiftManningAdminLog {
  static readonly type = '[ShiftManningAdminLog] Clear';
  constructor() {}
}
